import React from "react";
import { Container, Row, Col, Form, Alert } from "react-bootstrap";
import PropTypes from "prop-types";
import AccessNotes from "../shared/AccessNotes";

function WorkOrderAddress({ property }) {
  return (
    property != null && (
      <Container className="coreContent">
        <Row className="mb-4">
          <Col xs={2}>
            <Form.Label className="form-label-heading">Property Id:</Form.Label>
          </Col>
          <Col xs={4}>
            <Form.Label>{property.id}</Form.Label>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col xs={2}>
            <Form.Label className="form-label-heading">Address</Form.Label>
          </Col>
          <Col xs={6}>
            <Form.Control type="text" readOnly value={property.fullAddress} />
          </Col>
        </Row>
        <Row className="mt-1">
          <Col xs={2}>
            <Form.Label className="form-label-heading">Postcode</Form.Label>
          </Col>
          <Col xs={2}>
            <Form.Control type="text" readOnly value={property.postCode} />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={2}>
            <Form.Label className="form-label-heading">Site</Form.Label>
          </Col>
          <Col xs={6}>
            <Form.Control type="text" readOnly value={property.siteName} />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={2}>
            <Form.Label className="form-label-heading">Access Notes</Form.Label>
          </Col>
          <Col xs={6}>
            <AccessNotes accessNotes={property.accessNotes} />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={2}>
            <Form.Label className="form-label-heading">
              Property Access Notes
            </Form.Label>
          </Col>
          <Col xs={6}>
            <Form.Control
              as="textarea"
              readOnly
              value={property.propertyAccessNotes}
            />
          </Col>
        </Row>
        {property.redFlag && (
          <Row className="mt-4">
            <Col xs={8}>
              <Alert variant="danger">
                Caution - This Property has a Red Flag set on it.
              </Alert>
            </Col>
          </Row>
        )}
      </Container>
    )
  );
}

WorkOrderAddress.propTypes = {
  property: PropTypes.shape({
    id: PropTypes.string,
    fullAddress: PropTypes.string,
    postCode: PropTypes.string,
    siteName: PropTypes.string,
    accessNotes: PropTypes.arrayOf(PropTypes.string),
    propertyAccessNotes: PropTypes.string,
    redFlag: PropTypes.bool,
  }).isRequired,
};

export default WorkOrderAddress;
